import { FAQMeta, IBlockContent } from 'interfaces';

export const getBlockFAQ = (content: IBlockContent[]): FAQMeta[] => {
  let result: FAQMeta[] = [];

  content.forEach((item) => {
    const find = item.blockItems.find((a) => a.type === 'faq')?.faq;

    if (find) {
      result = find;
    }
  });

  return result;
};
